import { render, staticRenderFns } from "./PostGridMod.vue?vue&type=template&id=6eb62411"
import script from "./PostGridMod.vue?vue&type=script&lang=js"
export * from "./PostGridMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports